import $ from "jquery";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Barcodes extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;
        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;

        var articles = Comm.Printing(sid);

        this.state = {
            Articles: articles,
        };

        this.Save = this.Save.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }
        if (Context.RenderNotOK(this.props.history)) return null;

        var articles = this.state.Articles.slice();

        // var self = this; // not used below

        return Context.HasRight("rbarcodes") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("barcodes")}</div>
                <div className="panel-body">
                    {Context.HasRight("ebarcodes") ? (
                        <button className="btn btn-primary" onClick={this.Save}>
                            {Translation.Trans("save")}
                        </button>
                    ) : null}

                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="70%">{Translation.Trans("print")}</th>
                                        <th width="30%">{Translation.Trans("limitkg")}</th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="scrollableDiv">
                                <table className="table table-striped">
                                    <tbody>
                                        {articles.map((obj) => (
                                            <tr>
                                                <td width="70%">
                                                    <div>
                                                        <input
                                                            id={"cbChecked" + obj.id}
                                                            permid={obj.id}
                                                            type="checkbox"
                                                            defaultChecked={obj.checked}
                                                            key={"input" + obj.id}
                                                        />
                                                        &nbsp;
                                                        <label htmlFor={"cbChecked" + obj.id}>
                                                            {obj.code}
                                                        </label>
                                                    </div>
                                                </td>
                                                <td width="30%">
                                                    <input
                                                        id={"tbLimit" + obj.id}
                                                        type="number"
                                                        className="form-control"
                                                        defaultValue={obj.limit}
                                                        key={"limit" + obj.id}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }

    Save() {
        var data = {};

        var sid = Context.GetContext().Sid;
        data.session = sid;
        var printed = [];
        $("input[id^=cbChecked]:checked").each(function (i, e) {
            var id = $(e).attr("permid");
            var limit = $("#tbLimit" + id).val();
            var data = {
                id: id,
                limit: limit !== "" ? parseFloat(limit) : null,
            };
            printed.push(data);
        });
        data.printed = JSON.stringify(printed);

        Comm.SavePrinted(data);

        var articles = Comm.Printing(sid);

        this.setState({
            Articles: articles,
        });
    }
}

export default Barcodes;



// WEBPACK FOOTER //
// ./src/pages/barcodes.js